
import {User} from "../../../models";
import {CmsPage} from "../../page/model/page";

export class MenuItem {
    id: string;
    page: CmsPage;
    name: string;
    tagTitle: string;
    order: number;
    parent: MenuItem;
    createdBy: User;
    updatedBy: User;
    createdAt: string;
    updatedAt: string;
    items: MenuItem[] = [];
}
